<div *ngIf="printer.showMeReport" id="viewerContent"></div>
<div class="ui-g-12">
  <div class="ui-g-12 ui-md-6"></div>
  <div class="ui-g-12 ui-md-6" style="text-align: right;">
    <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
  </div>
  <!-- Cliente -->
  <div class="ui-g-12 ui-md-4">
    <span class="label">{{ 'balance.customer' | translate }}</span>
  </div>
  <div class="ui-g-12 ui-md-8">
    <input style="width: 100%;" name="customer" type="text" pInputText class="fieldInput" [(ngModel)]="customer" disabled/>
  </div>
  <!-- Negozio -->
  <div class="ui-g-12 ui-md-4">
    <span class="label">{{ 'common.store_title' | translate }}</span>
  </div>
  <div class="ui-g-12 ui-md-8">
    <input style="width: 100%;" name="store" type="text" pInputText class="fieldInput" [(ngModel)]="storeName" disabled/>
  </div>
  <!-- Saldo Iniziale -->
  <div class="ui-g-12 ui-md-4">
    <span class="label">{{ 'reservations.startingBalance' | translate }}</span>
  </div>
  <div class="ui-g-12 ui-md-8">
    <input style="width: 100%;" name="balance" type="text" pInputText class="fieldInput" [(ngModel)]="startingBalance" disabled/>
  </div>
</div>
<!-- Table Gifts -->
<div class="ui-g-12">
  <app-kontable
    #table
    id="confirm-gifts-table"
    title="{{ 'reservations.gifts' | translate }}"
    [columns]="[
      {field: 'name', title: 'reservations.gift', filterType: customFilter, filterTemplate: noFilter},
      {field: 'points', title: 'reservations.points', filterType: customFilter, filterTemplate: noFilter},
      {field: 'contribution', title: 'reservations.contribution', bodyTemplate: contributionTemplate, filterType: customFilter, filterTemplate: noFilter},
      {field: 'code', title: 'catalog.itemCode', filterType: customFilter, filterTemplate: noFilter},
      {field: 'type', title: 'catalog.giftType', filterType: customFilter, filterTemplate: noFilter},
      {field: 'deliveryType', title: 'catalog.deliveryType', filterType: customFilter, filterTemplate: noFilter},
      {field: 'qty', title: 'reservations.qty', filterType: customFilter, filterTemplate: noFilter}
    ]"
    [source]="selectedGifts"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="false"
    [showGlobalFilter]="false"
    [showResetFiltersBtn]="false"
    [additionalRowCommands]="customRow"
  >
    <!-- Colonna senza filtri -->
    <ng-template #noFilter></ng-template>
    <!-- Template Contributo -->
    <ng-template #contributionTemplate data-testid="contributionTemplate" let-row>
      <span *ngIf="row.contribution">{{ row.contribution.toFixed(2) + '€' }}</span>
    </ng-template>
    <!-- Checkbox PDV -->
    <ng-template #customRow data-testid="customRow" let-row>
      <p-checkbox
        *ngIf="row.deliveryType.toUpperCase() === 'PUNTO VENDITA O INDIRIZZO DI CONSEGNA'"
        [(ngModel)]="row.pdv"
        [binary]="true"
        [label]="'reservations.pdv' | translate"
        (onChange)="setPdvOrHomeDelivery(); setContributions(row, true);">
      </p-checkbox>
    </ng-template>
  </app-kontable>
</div>
<div class="ui-g-12">
  <div class="ui-g-12 ui-md-6">
    <!-- Punti Spesi -->
    <span class="label">{{ 'reservations.pointsSpent' | translate }}</span>
    <input style="width: 100%;" name="point-spent" type="text" pInputText class="fieldInput" [(ngModel)]="pointsSpent" disabled/>
  </div>
  <!-- Contributo da pagare subito -->
  <div class="ui-g-12 ui-md-6">
    <span class="label">{{ 'reservations.immediateContribution' | translate }}</span>
    <!-- <div class="contribution-input-container">
      <input style="width: 100%;" name="immdiate-contribution" type="text" pInputText class="fieldInput" [(ngModel)]="immediateContribution" disabled/>
      <span class="contribution-currency">€</span>
    </div> -->
    <p class="contribution-value">{{ immediateContribution.toFixed(2) }}€</p>
  </div>
  <!-- Punti Residui -->
  <div class="ui-g-12 ui-md-6">
    <span class="label">{{ 'reservations.pointsLeft' | translate }}</span>
    <input style="width: 100%;" name="points-left" type="text" pInputText class="fieldInput" [(ngModel)]="pointsLeft" disabled/>
  </div>
  <!-- Contributo al Ritiro -->
  <div class="ui-g-12 ui-md-6">
    <span class="label">{{ 'reservations.pickupContribution' | translate }}</span>
    <!-- <div class="contribution-input-container">
      <input style="width: 100%;" name="pickup-contribution" type="text" pInputText class="fieldInput" [(ngModel)]="pickupContribution" disabled/>
      <span class="contribution-currency">€</span>
    </div> -->
    <p class="contribution-value">{{ pickupContribution.toFixed(2) }}€</p>
  </div>
</div>

<!-- Modalità Consegna -->
<div class="ui-g-12">
  <h2 class="useful-info-title">{{ 'reservations.usefulInfoTitle' | translate }}</h2>
</div>

<!-- Dati Contatto -->
<div class="ui-g-12 delivery-info-section">
  <span class="label delivery-info-title">{{ 'reservations.contactData' | translate }}</span>
  <!-- Email -->
  <div class="ui-g-12">
    <strong>{{ 'reservations.emailAddress' | translate }}:</strong>
    <span *ngIf="customerEmail">{{ customerEmail }}</span>
  </div>
  <!-- Telefono -->
  <div class="ui-g-12">
    <strong>{{ 'reservations.phone' | translate }}:</strong>
    <span *ngIf="customerPhone">{{ customerPhone }}</span>
  </div>
  <!-- Button Aggiorna Dati Anagrafici -->
  <div class="ui-g-12">
    <button
      pButton
      class="k-generic-btn"
      (click)="showUpdatePersonalDataDialog = true"
      type="button"
      label="{{'reservations.editEmailPhone' | translate}}">
    </button>
  </div>
</div>

<!-- Consegna in Negozio
<div class="ui-g-12 delivery-info-section" *ngIf="pdvDelivery || pdvOrHomeDelivery === 'pdv'">
  <span class="label delivery-info-title">{{ 'reservations.pdvDeliveryGifts' | translate }}</span>
  <div class="ui-g-12" >
    <span class="label">{{ 'reservations.chosenPdv' | translate }}</span>
    <p-dropdown
      class="reservation-dropdown"
      [options]="deliveryStores"
      [(ngModel)]="selectedPdv"
      name="pdv"
      [autoWidth]="false"
      [filter]="true">
    </p-dropdown>
  </div>
</div> -->

<div class="ui-g-12 delivery-info-section" *ngIf="pdvDelivery || pdvOrHomeDelivery === 'pdv'">
  <span class="label delivery-info-title">{{ 'reservations.pdvDeliveryGifts' | translate }}</span>
  <div class="ui-g-12 auto-complete" >
    <span class="label">{{ 'reservations.chosenPdv' | translate }}</span>
    <!-- Pdv -->
      <app-store-autocomplete
      [storeDetailComplete]="true"
      [selectedStore]="selectedPdv"
      (selectedStoreChange)="changeStore($event)">
      </app-store-autocomplete>
  </div>
</div>

<!-- Consegna Digitale -->
<div class="ui-g-12 delivery-info-section" *ngIf="digitalDelivery">
  <span class="label delivery-info-title">{{ 'reservations.digitalDeliveryGifts' | translate }}</span>
  <!-- Email -->
  <div class="ui-g-12">
    <span class="label">{{ 'reservations.emailAddress' | translate }}<span style="color: #d00;">*</span></span>
    <input pInputText type="email" [(ngModel)]="reservationEmail" style="width: 50%;">
  </div>
</div>

<!-- Consegna a Domicilio -->
<div class="ui-g-12 delivery-info-section" *ngIf="homeDelivery || pdvOrHomeDelivery === 'home'">
  <div class="ui-g-12">
    <div class="ui-g-12 ui-md-6">
      <span class="label delivery-info-title">{{ 'reservations.homeDeliveryGifts' | translate }}</span>
    </div>
    <div class="ui-g-12 ui-md-6"></div>
  </div>
  <!-- Telefono -->
  <div class="ui-g-12">
    <span class="label">{{ 'reservations.phone' | translate }}<span style="color: #d00;">*</span></span>
    <input pInputText type="text" [(ngModel)]="reservationPhone" style="width: 50%;">
  </div>
  <!-- Indirizzo -->
  <div class="ui-g-12">
    <span class="label">{{ 'reservations.deliveryAddress' | translate }}<span style="color: #d00;">*</span></span>
    <p-dropdown
      class="reservation-dropdown"
      [options]="customerAddressList"
      [(ngModel)]="selectedCustomerAddress"
      name="customer-address"
      [autoWidth]="false">
    </p-dropdown>
  </div>
  <!-- Button Aggiungi Indirizzo -->
  <div class="ui-g-12">
    <button
      pButton
      class="k-generic-btn"
      (click)="openAddAddressDialog()"
      type="button"
      label="{{'reservations.newAddress' | translate}}">
    </button>
  <!-- Button Aggiorna Indirizzo -->
    <button
      pButton
      class="k-generic-btn"
      (click)="openEditAddressDialog()"
      type="button"
      label="{{'reservations.updateAddress' | translate}}">
    </button>
  </div>
</div>
<div class="ui-g-12" style="text-align: center;">
  <!-- Button Conferma Prenotazione -->
  <button
    pButton
    class="k-generic-btn"
    (click)="confirmReservation()"
    type="button"
    label="{{'reservations.confirmReservation' | translate}}">
  </button>
</div>

<p-dialog
  id="update-personal-data-dialog"
  *ngIf="showUpdatePersonalDataDialog"
  header="{{ 'reservations.updatePersonalData' | translate }}"
  [width]="1000"
  [(visible)]="showUpdatePersonalDataDialog"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
>
  <app-update-personal-data-form
    [customerEmail]="customerEmail"
    [customerPhone]="customerPhone"
    (personalDataUpdated)="refreshCustomerData()"
  >
  </app-update-personal-data-form>
</p-dialog>

<p-dialog
  id="add-address-dialog"
  *ngIf="showNewAddressDialog"
  header="{{ 'reservations.enterAddress' | translate }}"
  [width]="1000"
  [(visible)]="showNewAddressDialog"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
>
  <app-new-address-form
    [editAddress]="editAddress"
    [customerAddressList]="customerAddressList"
    [selectedCustomerAddress]="selectedCustomerAddress"
    (addressUpdated)="refreshCustomerData($event);"
  >
  </app-new-address-form>
</p-dialog>

<p-confirmDialog key="confirmRes" [closable]="false"></p-confirmDialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/confirm-gift-reservation-form.component.html